import { z } from 'zod';

/** URL contract and shared normalization for server-side library record search. */
export const metadataLibrarySearchSchema = z
  .object({
    q: z.string().trim().min(1).optional().catch(undefined),
    organizationId: z.array(z.string()).optional().catch(undefined),
  })
  .transform((search) => ({
    q: search.q,
    organizationId: search.organizationId,
  }));

export function normalizeMetadataLibraryQuery(value: string | null | undefined) {
  return value?.trim() || undefined;
}
